import React from "react";
import TradeInAemNavigation from "./common/navigation/TradeInAemNavigation";
import { TradeInAemNavStep } from "../../utils/constants";
import { useTradeInAemSelector } from "../../redux/store";
import FindVehicleContainer from "./find-vehicle/FindVehicleContainer";
import VehicleDetailsContainer from "./vehicle-details/VehicleDetailsContainer";
import TradeInAemModelSelectContainer from "./model-select/TradeInAemModelSelectContainer";
import SelectDealerContainer from "./dealer-finder/DealerFinderContainer";
import ContactFormContainer from "./contact-form/ContactFormContainer";
import TradeInAemSummaryContainer from "./summary/TradeInAemSummaryContainer";
import TradeInAemStepHeader from "./common/TradeInAemStepHeader";
import VehicleValueContainer from "./vehicle-value/VehicleValueContainer";
import ValuationLoadingContainer from "./common/valuation/ValuationLoadingContainer";
import ValuationFailedContainer from "./common/valuation/ValuationFailedContainer";
import useStatus from "../../../common-deprecated/hooks/useStatus";
import { useModalMap } from "../../../common-deprecated/containers/ModalProvider";
import { getTradeInAemExtraQueryBuilderOptions } from "../../utils/utils";
import { aemToyotaTradeInModalMap } from "./modals/modals";
import useTradeInAem from "../../hooks/useTradeInAem";
import { useTradeInCsl } from "../../csl/tradeInCslUtils";
import useDataFetcher from "../../../common-deprecated/hooks/useDataFetcher";
import type { GetFetchesFnType } from "../../../common-deprecated/utils/registryTypes";
import { COMPONENT_TRADEIN_AEM } from "../../../shared-logic/server/components";
import { getTradeInAemComponentFetches, tradeInAemFetchDispatcher } from "../../datafetch/fetchUtils";
import { MODAL_TRADE_IN_AEM_DEBUG } from "../../utils/modalConstants";

const componentMap: Record<TradeInAemNavStep, React.ReactElement> = {
    [TradeInAemNavStep.FindVehicle]: <FindVehicleContainer />,
    [TradeInAemNavStep.VehicleDetails]: <VehicleDetailsContainer />,
    [TradeInAemNavStep.VehicleValue]: <VehicleValueContainer />,
    [TradeInAemNavStep.ModelSelect]: <TradeInAemModelSelectContainer />,
    [TradeInAemNavStep.DealerFinder]: <SelectDealerContainer />,
    [TradeInAemNavStep.ContactForm]: <ContactFormContainer />,
    [TradeInAemNavStep.Summary]: <TradeInAemSummaryContainer />,
};

const TradeInAemContentContainer = (): JSX.Element | null => {
    const valuationLoading = useTradeInAemSelector((state) => state.tradeInAemVehicleValue.fetching);
    const valuationFailed = useTradeInAemSelector((state) => state.tradeInAemVehicleValue.failed);
    const eHubLoading = useTradeInAemSelector((state) => state.tradeInAemUtils.eHub.submitting);
    const eHubFailed = useTradeInAemSelector((state) => state.tradeInAemUtils.eHub.failed);
    const step = useTradeInAemSelector((state) => state.tradeInAemNav.step);

    let component = null;

    // Render separate container on vehicleValue or summary when valuation is loading or failed loading
    if (step === TradeInAemNavStep.VehicleValue || step === TradeInAemNavStep.Summary) {
        if (valuationLoading || eHubLoading) component = <ValuationLoadingContainer />;
        if (valuationFailed || eHubFailed) component = <ValuationFailedContainer />;
    }

    if (!component) component = componentMap[step];

    return component;
};

type Props = {
    insideModal?: boolean; // Indicates the trade-in component is shown inside a modal.
};
const TradeInAem = ({ insideModal }: Props): JSX.Element => {
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const csl = useTradeInCsl();
    const extraQueryBuilderOptions = getTradeInAemExtraQueryBuilderOptions(csl, commonSettings);

    useDataFetcher(
        getTradeInAemComponentFetches as GetFetchesFnType,
        tradeInAemFetchDispatcher,
        COMPONENT_TRADEIN_AEM,
        [],
        ["brand"],
    );
    useTradeInAem(insideModal);
    useModalMap(aemToyotaTradeInModalMap);
    useStatus(
        commonSettings,
        "Trade-In AEM",
        [],
        [{ key: "d", settings: { type: MODAL_TRADE_IN_AEM_DEBUG } }],
        extraQueryBuilderOptions,
    );

    return (
        <div>
            <TradeInAemNavigation insideModal={insideModal} />
            <TradeInAemStepHeader />
            <TradeInAemContentContainer />
        </div>
    );
};

export default TradeInAem;
